import { useEffect } from 'react';
import { AppSubdomains } from 'src/types/common';

const useFaviconAndTitle = () => {
  useEffect(() => {
    const hostParts = window.location.hostname.split('.');
    let sub = hostParts[0];
    if (sub === 'www' && hostParts.length > 1) {
      sub = hostParts[1];
    }

    const icons: Record<AppSubdomains, string> = {
      [AppSubdomains.Pari]: '/pari_icon.png',
      [AppSubdomains.Homebar]: '/homebar-small-icon.png',
      [AppSubdomains.Terea]: '/pari_icon.png',
    };

    const titles: Record<AppSubdomains, string> = {
      [AppSubdomains.Homebar]: 'HOMEBAR',
      [AppSubdomains.Terea]: 'Pari',
      [AppSubdomains.Pari]: 'Pari',
    };

    const href = icons[sub as AppSubdomains] || '/pari_icon.png';
    const title = titles[sub as AppSubdomains] || 'Pari';

    let link = document.getElementById('favicon') as HTMLLinkElement | null;
    if (!link) {
      link = document.createElement('link');
      link.id = 'favicon';
      link.rel = 'icon';
      document.head.appendChild(link);
    }

    const cacheBuster = '?v=' + Date.now();
    link.href = href + cacheBuster;

    document.title = title;
  }, []);
};

export default useFaviconAndTitle;
